import styled from 'styled-components';

import { Heading, StyledFlex } from '@dreryk/react-components';

import { StyledCard } from './shared/Card.styled';

export const StyledGifDecisionsCard = styled(StyledCard)`
   display: flex;
   flex-direction: column;
   height: 100%;
   min-width: 334px;
`;
StyledGifDecisionsCard.displayName = 'StyledGifDecisionsCard';

export const StyledGifDecisionsCardHeader = styled(StyledFlex)`
   width: 100%;
`;
StyledGifDecisionsCardHeader.displayName = 'StyledGifDecisionsCardHeader';

export const StyledHeading = styled(Heading)`
   white-space: nowrap;
`;
StyledHeading.displayName = 'StyledHeading';

export const StyledGifDecisionsList = styled.div`
   display: flex;
   width: 100%;
   flex-direction: column;
   gap: 4px;
`;
StyledGifDecisionsList.displayName = 'StyledGifDecisionsList';
